/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import {
  Grid, Card, CardHeader, CardContent, Tooltip, Button, Box, Typography, Divider, Paper, IconButton, Menu, MenuItem,
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import type { GridColumns } from '@material-ui/data-grid';
import {
  DataGrid,
} from '@material-ui/data-grid';
import {
  makeStyles, createStyles,
} from '@material-ui/core/styles';
import globalUseStyles from '../../globalClasses';
import { colors } from '../../theme';
import type { IMetalBin } from './MetalBinInterfaces';

const useStyles = makeStyles(() => createStyles({
  textBlue: {
    color: colors.primary,
  },
}));

interface MetalBinLookupProps {
  data: IMetalBin[] | undefined,
  setEditMetalBinFormValues: (value: IMetalBin) => void,
  setShowModal: (value: boolean) => void,
  deleteMetalBin: () => void,
}

const MetalBinLookup: React.FC<MetalBinLookupProps> = ({
  data, setEditMetalBinFormValues, setShowModal, deleteMetalBin,
}) => {
  const classes = useStyles();
  const globalStyles = globalUseStyles();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [pageSize, setPageSize] = React.useState(100);

  const handleVertIconClick = (event: React.MouseEvent<HTMLButtonElement>, guidParam: string) => {
    if (!anchorEl) {
      setAnchorEl(event.currentTarget);
      if (data?.filter((bin) => bin.id === guidParam)[0]) {
        setEditMetalBinFormValues(data?.filter((bin) => bin.id === guidParam)[0]);
      }
    }
  };

  const tableColumns: GridColumns = [
    {
      field: 'metalType',
      headerName: 'Metal Type',
      flex: 1,
    },
    {
      field: 'ringThickness',
      headerName: 'Ring Thickness',
      flex: 1.25,
    },
    {
      field: 'ringWidth',
      headerName: 'Ring Width',
      flex: 1,
    },
    {
      field: 'sizeChange',
      headerName: 'Change in Size',
      flex: 1,
    },
    {
      field: 'metalBinName',
      headerName: 'Metal Bin',
      flex: 1,
    },
    {
      field: 'id',
      headerName: 'Actions',
      flex: 0.75,
      renderCell: ({ value }) => (
        ((typeof (value) === 'string')
          ? (
            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={(event: React.MouseEvent<HTMLButtonElement>) => handleVertIconClick(event, value)}
            >
              <MoreVertIcon />
            </IconButton>
          )
          : <></>
        )
      ),
    },
  ];

  const tableRows = data && data?.map((bin, index) => ({
    id: bin.id || index,
    metalType: bin.metalType?.label || '',
    ringThickness: bin.ringThickness ? `${bin.ringThickness}mm` : '',
    ringWidth: bin.ringWidth ? `${bin.ringWidth}mm` : '',
    sizeChange: bin.sizeChange ? `${bin.sizeChange}mm` : '',
    metalBinName: bin.metalBinName || '',
  }));

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleEditBin = () => {
    setShowModal(true);
  };

  return (
    <>
      <Paper>
        <Card>
          <CardHeader
            title={(
              <Typography variant="h6" className={classes.textBlue} display="inline">{'Metal Cart'}</Typography>
              )}
            disableTypography
          />
          <CardContent>
            <Box height={((pageSize + 1) * 52) + 60}>
              <DataGrid
                rows={tableRows || []}
                columns={tableColumns}
                pageSize={pageSize}
                loading={!data}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                className={globalStyles.transparentDataGrid}
              />
            </Box>
            {anchorEl
              && (
                <Menu
                  anchorEl={anchorEl}
                  keepMounted
                  open
                  onClose={handleCloseMenu}
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                >
                  <MenuItem id="edit-bin-button" onClick={() => { handleEditBin(); handleCloseMenu(); }}>{'Edit'}</MenuItem>
                  <MenuItem id="delete-bin-button" onClick={() => { deleteMetalBin(); handleCloseMenu(); }}>{'Delete'}</MenuItem>
                </Menu>
              )}
          </CardContent>
        </Card>
      </Paper>
    </>
  );
};

export default MetalBinLookup;
